import type React from 'react';

type TextField = HTMLInputElement | HTMLTextAreaElement;

export const noSelectionTextInputProps = {
  onContextMenu: (event: React.MouseEvent<TextField>) => event.preventDefault(),
  onSelect: (event: React.SyntheticEvent<TextField>) => {
    const input = event.currentTarget;
    const end = input.value.length;
    if (input.selectionStart !== end || input.selectionEnd !== end) {
      input.setSelectionRange(end, end);
    }
  },
};
